import { locale } from "./local";


export const formatInt = (value: null | number | undefined): string => {
	if (value === null || value === undefined) {
		return "--";
	}

	return new Intl.NumberFormat(locale, {
		maximumFractionDigits: 0,
		minimumFractionDigits: 0,
	}).format(value);
};

export const formatCompactInt = (value: null | number | undefined): string => {
	if (value === null || value === undefined) {
		return "--";
	}

	return new Intl.NumberFormat(locale, {
		notation: "compact",
		maximumFractionDigits: 1,
	}).format(value);
};

export const formatDecimal = (
	value: null | number | undefined,
	digits: number,
): string => {
	if (value === null || value === undefined) {
		return "--";
	}

	return new Intl.NumberFormat(locale, {
		maximumFractionDigits: digits,
		minimumFractionDigits: digits,
	}).format(value);
};
